import React from 'react'
import { useTranslation } from 'react-i18next'
import { BeWizrLibraryTopic } from '~/models'
import { bewizrLibraryStore } from '~/stores'
import { observer } from '~/ui/component'
import { EmptyOrFetching, Scroller } from '~/ui/components'
import { AppLayoutConfig } from '~/ui/layouts'
import { layout } from '~/ui/styling'
import BeWizrGrid from '../bewizr/BeWizrGrid'
import BeWizrLibraryTopicTile from './BeWizrLibraryTopicTile'

const BeWizrLibraryTopicsScreen = observer('BeWizrLibraryTopicsScreen', () => {

  const [t] = useTranslation('bewizr-library')

  const topicsEndpoint = bewizrLibraryStore.allTopics

  const fetchStatus = topicsEndpoint.fetchStatus

  const fetchMore = React.useCallback(() => {
    topicsEndpoint?.fetchMore()
  }, [topicsEndpoint])

  const fetch = React.useCallback(() => {
    topicsEndpoint.fetch()
  }, [topicsEndpoint])

  React.useEffect(() => {
    fetch()
  }, [fetch])

  const empty = fetchStatus !== 'done' || topicsEndpoint.empty

  //------
  // Rendering

  function render() {
    return (
      <>
        <AppLayoutConfig
          title={t('title')}
        />
        <Scroller contentPadding={layout.padding.m} onEndReached={fetchMore}>
          {empty ? renderEmpty() : renderBody()}
        </Scroller>
      </>
    )
  }

  function renderEmpty() {
    return (
      <EmptyOrFetching
        {...t('topics.empty')}
        status={fetchStatus}
        flex
      />
    )
  }

  function renderBody() {
    return (
      <BeWizrGrid
        endpoint={topicsEndpoint}
        renderItem={rendertopic}
      />
    )
  }

  function rendertopic(topic: BeWizrLibraryTopic) {
    return (
      <BeWizrLibraryTopicTile
        topic={topic}
      />
    )
  }

  return render()

})

export default BeWizrLibraryTopicsScreen